import type { TFunction } from "i18next";
import type { Schema } from "@/shared/components/Form/types";
import { countryOptions } from "@/shared/utils/countries";
import { AvailableOrganizationsAutocompleteQuery } from "@/partner/entities/organizations";

export interface TimezoneOption {
  value: string;
  label: string;
}

export function getUserSettingsSchema(
  t: TFunction,
  timezoneOptions: TimezoneOption[]
): Schema {
  return {
    firstName: {
      type: "text",
      label: t("userSettings.form.firstNameLabel"),
      xs: 12,
      sm: 6,
      variant: "outlined",
      fullWidth: true,
    },
    lastName: {
      type: "text",
      label: t("userSettings.form.lastNameLabel"),
      xs: 12,
      sm: 6,
      variant: "outlined",
      fullWidth: true,
    },
    country: {
      type: "autocomplete",
      label: t("userSettings.form.countryLabel"),
      xs: 12,
      options: countryOptions,
      fullWidth: true,
    },
    language: {
      type: "autocomplete",
      label: t("userSettings.form.languageLabel"),
      xs: 12,
      sm: 6,
      // Лейблы берём из общей ветки shared.language.* (совпадает с
      // LanguageAutocomplete). Список сознательно захардкожен — i18n
      // кабинета сейчас поддерживает только "ru"/"en" (см. supportedLngs
      // в app/providers/i18n.ts).
      options: [
        { value: "ru", label: t("shared.language.ru") },
        { value: "en", label: t("shared.language.en") },
      ],
      fullWidth: true,
    },
    timeZone: {
      type: "autocomplete",
      label: t("userSettings.form.timeZoneLabel"),
      xs: 12,
      sm: 6,
      options: timezoneOptions,
      fullWidth: true,
    },
    currentOrganizationId: {
      type: "autocomplete",
      label: t("userSettings.form.organizationLabel"),
      xs: 12,
      query: AvailableOrganizationsAutocompleteQuery,
      fullWidth: true,
    },
    agreeToMarketingNewsletters: {
      type: "switch",
      label: t("userSettings.form.marketingLabel"),
      xs: 12,
    },
  };
}
